import { createAsyncThunk } from "@reduxjs/toolkit";
import { type TeamAmbassador } from "../../../domain/entities/team";
import { type TeamDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getTeam = createAsyncThunk<
  TeamAmbassador[],
  { supervisorId: string; businessDate: string },
  { dispatch: TeamDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_TEAM, async ({ supervisorId, businessDate }, { extra }) => {
  return await extra.teamRepo.getTeam(supervisorId, businessDate);
});
